import { render, staticRenderFns } from "./SimsSolicitudes.vue?vue&type=template&id=b46df808&"
import script from "./SimsSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./SimsSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./SimsSolicitudes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b46df808', component.options)
    } else {
      api.reload('b46df808', component.options)
    }
    module.hot.accept("./SimsSolicitudes.vue?vue&type=template&id=b46df808&", function () {
      api.rerender('b46df808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/RegistrarBajaSim/ModalProcesar/SimsSolicitudes.vue"
export default component.exports